import { Button, StatusMessage } from '@krp/ui-kit'
import type { QueryView } from '@krp/client-runtime'

import { errorMeta } from './errorMeta'

/**
 * Не-«готовые» состояния запроса одинаково во всех окнах пакета: загрузка,
 * пусто, нет входа, нет доступа, недоступно, ошибка. Текст сервера —
 * дословно (ADR-8).
 */
export function QueryState({
  query,
  emptyText,
  onRetry,
  what,
}: {
  query: QueryView
  emptyText: string
  onRetry: () => void
  /** Что не загрузилось: «Кассы», «Каталог» — чтобы два состояния на экране различались. */
  what?: string
  /** Совместимость вызывающих окон: ошибки всегда показывают код и номер запроса по решению владельца19.10.2026. */
  requestIdHidden?: boolean
}) {
  const meta = errorMeta(query.error)
  const prefix = what !== undefined ? `${what}: ` : ''
  const retry = (
    <Button variant="secondary" onClick={onRetry}>
      Повторить
    </Button>
  )
  switch (query.status) {
    case 'idle':
    case 'loading':
      return <StatusMessage kind="loading" title={`${prefix}загрузка…`} />
    case 'empty':
      return <StatusMessage kind="empty" title={emptyText} />
    case 'unauthorized':
      return <StatusMessage kind="unauthorized" title="Сессия завершена" text="Войдите снова, чтобы продолжить." />
    case 'forbidden':
      return (
        <StatusMessage
          kind="forbidden"
          title={`${prefix}нет доступа`}
          {...(query.error !== null ? { text: query.error.message } : {})}
          {...(meta !== undefined ? { meta } : {})}
        />
      )
    case 'unavailable':
      // Сбой связи (сеть, таймаут) показывает общее окно приложения по центру экрана — здесь только строка ожидания.
      if (query.error?.kind === 'network' || query.error?.kind === 'timeout') {
        return <StatusMessage kind="loading" title={`${prefix}загрузка…`} />
      }
      return (
        <StatusMessage
          kind="unavailable"
          title={`${prefix}служба недоступна`}
          {...(query.error !== null ? { text: query.error.message } : {})}
          {...(meta !== undefined ? { meta } : {})}
          action={retry}
        />
      )
    case 'error':
      return (
        <StatusMessage
          kind="error"
          title={`${prefix}ошибка`}
          {...(query.error !== null ? { text: query.error.message } : {})}
          {...(meta !== undefined ? { meta } : {})}
          action={retry}
        />
      )
    case 'ready':
      return null
  }
}
